import React from "react";

const HelloprenupLogoWithBlueBackground: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 320 320"
      fill="none"
    >
      <g clipPath="url(#a)">
        <mask
          id="b"
          width="320"
          height="320"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
        >
          <path
            fill="#fff"
            d="M320 160c0 88.365-71.635 160-160 160S0 248.365 0 160 71.635 0 160 0s160 71.635 160 160"
          />
        </mask>
        <g mask="url(#b)">
          <path fill="#0F2162" d="M352-32H-32v384h384z" />
        </g>
        <mask
          id="c"
          width="199"
          height="182"
          x="56"
          y="86"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
        >
          <path fill="#fff" d="M56 86.667h198.667V267.76H56z" />
        </mask>
        <g mask="url(#c)">
          <path
            fill="#FFBF5E"
            d="M233.411 108.786c-6.369-6.552-13.807-11.708-22.093-15.323-8.589-3.734-17.724-5.63-27.13-5.63a67.7 67.7 0 0 0-27.136 5.63c-8.286 3.615-15.724 8.771-22.094 15.323a71.8 71.8 0 0 0-13.479 19.505c-16.646 1.224-32.146 8.323-44.057 20.334-13.078 13.177-20.266 30.666-20.266 49.25 0 18.588 7.214 36.104 20.292 49.255 13.13 13.229 30.604 20.505 49.224 20.505 18.625 0 36.094-7.276 49.224-20.505a68.7 68.7 0 0 0 12.359-16.865 68.1 68.1 0 0 0 23.089-5.505c8.286-3.614 15.724-8.771 22.088-15.323 13.084-13.453 20.271-31.318 20.271-50.323-.026-19.01-7.213-36.875-20.292-50.328m-96.281 42.229c21.297 4.808 37.245 23.99 37.245 46.86 0 3.265-.323 6.432-.948 9.521-21.141-5.084-36.943-24.818-36.943-48.282 0-2.745.224-5.458.646-8.099m-10.479 94.896c-26.312 0-47.703-21.552-47.703-48.036 0-22.469 15.427-41.407 36.167-46.61a75 75 0 0 0-.422 7.849c0 19.005 7.213 36.87 20.265 50.323 6.37 6.552 13.808 11.709 22.094 15.323a70 70 0 0 0 7.162 2.641c-8.709 11.26-22.313 18.51-37.563 18.51m68.865-38.667c.401-3.088.625-6.203.625-9.369 0-18.584-7.188-36.073-20.266-49.25-8.641-8.719-19.172-14.849-30.682-18.016 8.64-12.729 22.89-21.052 38.995-21.052 26.307 0 47.697 22.224 47.697 49.557.026 23.266-15.5 42.849-36.369 48.13"
          />
        </g>
        <mask
          id="d"
          width="53"
          height="51"
          x="41"
          y="85"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
        >
          <path fill="#fff" d="M41.23 85.334h52.104V136H41.23z" />
        </mask>
        <g mask="url(#d)">
          <path
            fill="#0BA1F5"
            d="M82.219 86.39a14 14 0 0 0-5.844-.697c-1.969.172-3.896.77-5.64 1.718a14.2 14.2 0 0 0-4.47 3.886 14.9 14.9 0 0 0-2.62 5.36l-.848 3.234-2.495-.646c-7.792-2.193-16 2.093-18.349 9.567a15.18 15.18 0 0 0-.073 8.943c.896 2.917 2.62 5.505 4.964 7.375a14.6 14.6 0 0 0 5.27 2.74l27.63 7.625c.5.151 1 .172 1.527.099a3.8 3.8 0 0 0 1.442-.5c.454-.25.829-.594 1.151-1.021.297-.396.526-.87.651-1.37l7.136-27.479c2.02-7.974-2.219-16.417-9.432-18.833"
          />
        </g>
        <mask
          id="e"
          width="51"
          height="51"
          x="228"
          y="51"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
        >
          <path fill="#fff" d="M228 51.813h50.667v49.52H228z" />
        </mask>
        <g mask="url(#e)">
          <path
            fill="#0BA1F5"
            d="M278.291 80.286c-.203-2.02-.776-3.963-1.75-5.729a14.35 14.35 0 0 0-3.843-4.536 14.7 14.7 0 0 0-5.292-2.615 14.1 14.1 0 0 0-5.865-.276l-3.244.5-.401-2.594c-1.198-8.093-8.36-14.047-15.974-13.203a14.4 14.4 0 0 0-5.641 1.818 14.7 14.7 0 0 0-4.469 3.911 15.1 15.1 0 0 0-2.599 5.407 15.3 15.3 0 0 0-.297 6.005l4.318 28.776c.073.52.25.995.5 1.442.276.454.625.823 1.021 1.152a3.8 3.8 0 0 0 2.896.692l27.583-4.432c7.964-1.219 13.807-8.568 13.057-16.318"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h320v320H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HelloprenupLogoWithBlueBackground;
